import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useUtils as useI18nUtils } from '@core/libs/i18n'

export default function useReviewList() {
    const { t } = useI18nUtils()
    const tableColumns = [
        { key: '', label: '', sortable: false },
        { key: 'cover_image', label: t('cover_image'), sortable: false, tdClass:'width-200 p-1' },
        { key: 'title', label: 'Title', sortable: false },
        { key: 'slug', label: 'Slug', sortable: false },
        { key: 'is_active', label: 'Status', sortable: false },
        { key: 'action', label: '#', sortable: false }
    ]
    const isReviewFormSidebarActive = ref(false)
    const reviewData = ref(null)
    const reviews = ref([])
    const totalReview = ref(0)
    const currentPage = ref(1)
    const perPage = ref(10)
    const searchQuery = ref('')
    const statusFilter = ref(null)
    const toast = useToast()
    const refReviewListTable = ref(null)
    const getLocalSite = JSON.parse(localStorage.getItem('site'))
    const dataMeta = computed(() => {
        const from = Math.max(1, perPage.value * (currentPage.value - 1) + 1);
        const to = Math.min(
            totalReview.value,
            perPage.value * currentPage.value
        );
        return {
            from,
            to,
            of: totalReview.value,
        }
    })

    const updateOrdering = () => {
        const filteredData = reviews.value?.filter(item => item !== undefined);

        store.dispatch('app-review/updateReviewOrdering', filteredData)
    }

    const refetchData = () => {
        // refReviewListTable.value.refresh()
        fetchData()
    }

    watch([currentPage, perPage, searchQuery, statusFilter], () => {
        fetchData()
    })

    const resolveReviewStatusVariant = status =>{
        if (status) return 'success'
        if (!status ) return 'secondary'
        return 'primary'
    }

    const resolveReviewStatusnameVariant = status => {
        if (status) return 'Active'
        if (!status) return 'Inactive'
        return 'primary'
    }

    const fetchData = (ctx, callback) => {
        const offset = perPage.value*(currentPage.value-1);

        store.dispatch(`app-review/getReviews`, {
            limit: perPage.value,
            offset: offset,
            keywords: searchQuery.value,
            order_by: 'ordering_count DESC',
            sites_id: getLocalSite.id
        })
        .then(response => {
            reviews.value = response.data.data
            totalReview.value = response.data.total
        })
        .catch(() => {
            toast({
                component: ToastificationContent,
                props: {
                    title: "Error fetching Guide' lists",
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                },
            })
        })
    }

    const updateReview = async (data) => {
        if(data){
            reviewData.value = data
        } else {
            reviewData.value = null;
        }
        
        isReviewFormSidebarActive.value = true
        fetchData()
    }

    const deleteData = (id) => {
        store.dispatch('app-review/deleteReview', id).then(response=>{
            toast({
                component: ToastificationContent,
                props: {
                title: "Delete Success",
                icon: 'AlertTriangleIcon',
                variant: 'success',
                },
            })

            fetchData();
        }).catch((error)=>{
            toast({
                component: ToastificationContent,
                props: {
                    title: "Error Delete Food Category",
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                },
            })
        })
    }

    return {
        tableColumns,
        isReviewFormSidebarActive,
        reviewData,
        refetchData,
        fetchData,
        currentPage,
        perPage,
        searchQuery,
        statusFilter,
        refReviewListTable,
        dataMeta,
        resolveReviewStatusVariant,
        resolveReviewStatusnameVariant,
        updateReview,
        reviews,
        updateOrdering,
        deleteData,
        totalReview,
    }
}